import React, { SVGProps } from "react";

const InProgressIcon: (props: React.SVGProps<SVGSVGElement>) => JSX.Element = ({
  height = "24px",
  width = "24px",
  stroke = "black",
  ...props
}: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width={height}
      height={width}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.9069 0.5H6.10354C2.27964 0.5 0 2.887 0 6.891V16.098C0 20.113 2.27964 22.5 6.10354 22.5H14.8964C18.7203 22.5 21 20.113 21 16.109V6.891C21.0105 2.887 18.7308 0.5 14.9069 0.5ZM16.031 9.256L13.6043 12.534C13.2996 12.941 12.8689 13.205 12.3752 13.26C11.8814 13.326 11.3982 13.183 11.0095 12.864L9.08703 11.28C9.01349 11.214 8.92945 11.214 8.88743 11.225C8.84541 11.225 8.77187 11.247 8.70884 11.335L6.20859 14.734C6.05101 14.943 5.8199 15.053 5.58878 15.053C5.4207 15.053 5.25262 14.998 5.10554 14.877C4.75887 14.602 4.69584 14.085 4.95847 13.722L7.45872 10.323C7.76337 9.916 8.19408 9.652 8.68783 9.586C9.17107 9.52 9.66481 9.663 10.0535 9.982L11.976 11.566C12.0495 11.632 12.123 11.632 12.1756 11.621C12.2176 11.621 12.2911 11.599 12.3542 11.511L14.7809 8.233C15.0435 7.87 15.5477 7.804 15.8839 8.09C16.2306 8.387 16.2936 8.904 16.031 9.256Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default InProgressIcon;
